import {
  ORDER_CREATE_FAIL,
  ORDER_CREATE_REQUEST,
  ORDER_CREATE_SUCCESS,
  ORDER_DETAILS_FAIL,
  ORDER_DETAILS_REQUEST,
  ORDER_DETAILS_SUCCESS,
  ORDER_PAY_FAIL,
  ORDER_PAY_REQUEST,
  ORDER_PAY_RESET,
  ORDER_PAY_SUCCESS,
  ORDER_RATES_FAIL,
  ORDER_RATES_REQUEST,
  ORDER_RATES_SUCCESS,
} from "../constants/orderConstants";

//Order Creating
export const orderCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_CREATE_REQUEST:
      return { loading: true };
    case ORDER_CREATE_SUCCESS:
      return { loading: false, success: true, order: action.payload };
    case ORDER_CREATE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

//Order Details request
export const orderDetailsReducer = (
  state = {},
  action
  // state = { loading: true, orderItems: [], shippingAddress: {} },
  // action
) => {
  switch (action.type) {
    case ORDER_DETAILS_REQUEST:
      return { ...state, loading: true };
    case ORDER_DETAILS_SUCCESS:
      return { loading: false, orders: action.payload };
    case ORDER_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

//Payment Part Paypal
export const orderPayReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_PAY_REQUEST:
      return { loading: true };
    case ORDER_PAY_SUCCESS:
      return { loading: false, order: action.payload };
    case ORDER_PAY_FAIL:
      return { loading: false, error: action.payload };
    case ORDER_PAY_RESET:
      return {};
    default:
      return state;
  }
};

//Payment Part Paypal
export const getRatesReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_RATES_REQUEST:
      return { loading: true };
    case ORDER_RATES_SUCCESS:
      return { loading: false, deliveryType: action.payload };
    case ORDER_RATES_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
